import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Skeleton, Text } from '@chakra-ui/react';
import { forwardRef } from 'react';
import { FoldDecimal } from '../FoldDecimal';
export const BasicNumber = forwardRef(({ value, prefix, suffix, fold, ...props }, ref) => {
    return (_jsx(Skeleton, { isLoaded: !!value, display: props.display, children: _jsxs(Flex, { align: "center", gap: "0.5", ...props, ref: ref, children: [prefix, !!value &&
                    (fold ? (_jsx(Text, { as: "span", whiteSpace: "nowrap", children: _jsx(FoldDecimal, { value: value, ignoreNotPure: true, prependZeroCount: 4 }) })) : (_jsx(Text, { as: "span", children: value }))), suffix] }) }));
});
BasicNumber.displayName = 'BasicNumber';
